import styled, { css } from 'styled-components';
import { btnReset } from '../../../stylesheets/tools';

const StyledAccessibilityButton = styled.button`
  cursor: pointer;
  ${btnReset}

  svg {
    fill: #000;
  }

  [data-whatinput='mouse'] &,
  [data-whatinput='touch'] & {
    outline: 0;
  }

  ${props =>
    props.inverted &&
    css`
      svg,
      g,
      path {
        fill: ${props.close ? props.theme.globalTheme.primary : '#fff'};
      }
    `}
`;

export default StyledAccessibilityButton;
